import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LocatelliHomeService } from "../../../services/locatelliHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { environment } from '../../../../environments/environment';
defineLocale("it", itLocale);
import * as moment from 'moment';

declare var jQuery: any;
@Component({
  selector: "app-transport-bonus-list",
  templateUrl: "./transport-bonus-list.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class TransportBonusListComponent implements OnInit {

  transportBonusPath;
  requestsPath;

  checkFirstPage;
  private sub: any;

  bonuses: any[] = new Array();
  errorMessage;

  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private locatelliService: LocatelliHomeService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {

      if ( params['token'] == undefined  ||  params['token'] == null ||  params['token'] == "" ) {
        this.checkFirstPage = false
      } else{
        this.checkFirstPage = true
      }
    });


    if (this.checkFirstPage == true)  {

      this.sub = this.route.params.subscribe(params => {
        var token  = params['token'];
        var user = params['user'];
        var language = params['language'];
        var role = params['role'];

        localStorage.setItem("token", token);
        localStorage.setItem("user", user)
        localStorage.setItem("language", language)
        localStorage.setItem("role", role)
        this.router.navigate(['/transport-bonus/list'])
      });

    }

    this.transportBonusPath = 'bonus/trasporti'
    this.requestsPath = 'richieste'
    this.getTrasportBonusRequested();
  }

  getTrasportBonusRequested() {
    this.spinner.show();

    this.locatelliService.getListFilter(this.transportBonusPath + '/' + this.requestsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.bonuses = response.results
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  formatDate(obj) {
    return moment(obj).toISOString();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/transport-bonus/transport-bonus-list/transport-bonus-list.component.ts